/**
 * HTML Structure Fix for Content Duplication
 * 
 * This script addresses the issue of content appearing both above and below the footer
 * by fixing improper HTML structure with multiple closing tags and duplicate content injection.
 * 
 * IMPORTANT: This script has been updated to work harmoniously with global-content-duplication-fix.js
 * by removing overlapping DOM method overrides and focusing only on HTML structure cleanup.
 */

(function() {
  // Wait for DOM to be fully loaded
  document.addEventListener('DOMContentLoaded', function() {
    console.log('HTML Structure Fix: Initializing');
    
    // Flag to indicate this script is active (used for coordination with other scripts)
    window.htmlStructureFixActive = true;
    
    // ===== FIX 1: Ensure proper HTML document structure =====
    function fixHtmlStructure() {
      // Check if there are any elements after the closing body tag
      const html = document.documentElement;
      const body = document.body;
      
      if (!html || !body) {
        console.log('HTML Structure Fix: Could not find html or body elements');
        return;
      }
      
      // Get all child nodes of the html element
      const htmlChildren = Array.from(html.childNodes);
      
      // Find the body element's index
      const bodyIndex = htmlChildren.indexOf(body);
      
      if (bodyIndex === -1) {
        console.log('HTML Structure Fix: Could not determine body position');
        return;
      }
      
      // Check if there are any elements after the body
      const elementsAfterBody = htmlChildren.slice(bodyIndex + 1).filter(node => 
        node.nodeType === 1 || (node.nodeType === 3 && node.textContent.trim().length > 0)
      );
      
      if (elementsAfterBody.length > 0) {
        console.log('HTML Structure Fix: Found elements after body, moving them inside body');
        
        // Move any elements after body to the end of body
        elementsAfterBody.forEach(node => {
          try {
            if (node.parentNode) {
              node.parentNode.removeChild(node);
              body.appendChild(node);
            }
          } catch (e) {
            console.log('HTML Structure Fix: Error moving node', e);
          }
        });
      }
    }
    
    // ===== FIX 2: Detect and remove duplicate content =====
    function removeDuplicateContent() {
      // Find the footer element
      const footer = document.querySelector('footer');
      
      if (!footer) {
        console.log('HTML Structure Fix: Could not find footer element');
        return;
      }
      
      // Check for duplicate content by comparing text content
      const contentElements = document.querySelectorAll('.ProductMeta, .Product__Info, [data-section-type="product-template"], .collection-description, .collection__description, .rte');
      const contentTexts = {};
      
      contentElements.forEach(function(el) {
        const text = el.textContent.trim();
        if (text.length > 50) {
          if (contentTexts[text]) {
            // Found duplicate content, remove it
            console.log('HTML Structure Fix: Removing duplicate content element');
            try {
              el.parentNode.removeChild(el);
            } catch (e) {
              console.log('HTML Structure Fix: Error removing duplicate content', e);
            }
          } else {
            contentTexts[text] = true;
          }
        }
      });
    }
    
    // ===== FIX 3: Prevent content injection after closing tags =====
    // NOTE: DOM method overrides have been moved to global-content-duplication-fix.js
    // to prevent conflicts between scripts
    
    // Run structure fixes only
    fixHtmlStructure();
    removeDuplicateContent();
    
    // Set up a MutationObserver to catch any future structure issues
    const observer = new MutationObserver(function(mutations) {
      let needsCleanup = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          // Check if mutation is adding nodes to html after body
          if (mutation.target === document.documentElement) {
            const bodyIndex = Array.from(document.documentElement.childNodes).indexOf(document.body);
            
            if (bodyIndex !== -1 && mutation.addedNodes.length > 0) {
              needsCleanup = true;
            }
          }
        }
      });
      
      if (needsCleanup) {
        console.log('HTML Structure Fix: Detected new issues, cleaning up');
        fixHtmlStructure();
        removeDuplicateContent();
      }
    });
    
    // Start observing the document structure
    observer.observe(document.documentElement, { 
      childList: true,
      subtree: false // Only watch for direct children of html element
    });
    
    console.log('HTML Structure Fix: Initialization complete');
  });
})();
